import { NAMES } from 'widget/redux/client/actions/videos';
import replaceArrays from 'widget/utils/replace-arrays';

export default (state = {}, { payload, type }) => {
  if (type === NAMES.UPDATE_VIDEO_LIVE_STATUS) {
    return {
      ...state,
      [payload.id]: payload,
    };
  }

  const videos = _.get(payload, 'response.data.entities.videos');
  if (videos) {
    return _.mergeWith({}, state, videos, replaceArrays);
  }

  return state;
};
